import { useSearchParams } from 'react-router'

import { SEARCH_PARAMS } from '@/lib/searchParams'

// TODO: Remove this hook. Don't need the unnecessary abstraction.
export function useCompanyProfileSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const params = {
    identifier: searchParams.get(SEARCH_PARAMS.companyProfile.identifier) || '',
    identifierType:
      searchParams.get(SEARCH_PARAMS.companyProfile.identifierType) || '',
    profileTab: searchParams.get(SEARCH_PARAMS.companyProfile.profileTab) || '',
  }

  function setParams(newParams: Partial<typeof SEARCH_PARAMS.companyProfile>) {
    Object.entries(newParams).forEach(([key, value]) => {
      searchParams.set(key, value.toString())
    })

    setSearchParams(searchParams)
  }

  function setTab(tab: string) {
    searchParams.set(SEARCH_PARAMS.companyProfile.profileTab, tab)
    setSearchParams(searchParams)
  }

  function clearParams() {
    searchParams.delete(SEARCH_PARAMS.companyProfile.identifier)
    searchParams.delete(SEARCH_PARAMS.companyProfile.identifierType)

    setSearchParams(searchParams)
  }

  return {
    searchParams: params,
    setParams,
    clearParams,
    setTab,
  }
}
